export default __webpack_public_path__ + "static/media/math-slide.ee1c46ea.gif";